import Select from '@chegg-wt/core/components/Select'
import { AppState } from '@chegg-wt/core/state'
import { sortOptions } from '@chegg-wt/core/state/bibliography/constants'
import { getHeader } from '@chegg-wt/core/utils/formattingExport'
import React from 'react'
import { connect } from 'react-redux'

import { sortCitations } from '@chegg-wt/core/state/bibliography/actions'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import * as Styled from './styled'

interface Props {
  enableSort: boolean
  citationStyle: string
  sortCitations: (sortKey: string) => void
}

const getTrigger = ({ isOpen, openDropdown }) => (
  <Styled.SortTrigger
    onClick={openDropdown}
    data-test="sort-button"
    aria-expanded={isOpen}
  >
    Sort by
    <Styled.Chevron size="small" pointing={isOpen ? 'up' : 'down'} />
  </Styled.SortTrigger>
)

export const WORKS_CITED_HEADER = 'works-cited-header'

const CitationListHeader: React.FC<Props> = ({
  enableSort,
  citationStyle,
  sortCitations,
}) => (
  <Styled.Container>
    <Styled.HeaderContainer>
      {/* NOTE (Re: WTAC-256) If this redesign test wins, QA tests may break due to missing CitationStyle in header  */}
      <Styled.LeftSpacer />
      <Styled.Header data-test={WORKS_CITED_HEADER}>
        {getHeader(citationStyle)}
      </Styled.Header>
      <Styled.DropdownContainer>
        <Select
          onSelect={sortCitations}
          options={enableSort ? sortOptions : [sortOptions[2]]}
          trigger={getTrigger}
          defaultOption={enableSort ? sortOptions[0] : sortOptions[2]}
          width="medium"
          type="sort"
        />
      </Styled.DropdownContainer>
    </Styled.HeaderContainer>
  </Styled.Container>
)

const mapStateToProps = (state: AppState) => ({
  citationStyle: currentStyleSelector(state),
})

const mapDispatchToProps = { sortCitations }

export default connect(mapStateToProps, mapDispatchToProps)(CitationListHeader)
